import handleToggleByIndex from '../common/handleToggleByIndex';

/**
 * Returns a callback that initializes the tabs component with the first tab active.
 * @param {Element} component
 * @returns {Function}
 */
const handleInit = (component) => () => {
    const $tabItems = $(component).find('.tabs__item');
    const $contents = $(component).find('.tabs__content');

    const initialIndex = $tabItems.filter('[data-active="true"]').index();
    const index = initialIndex > -1 ? initialIndex : 0;

    handleToggleByIndex($tabItems, index)();
    handleToggleByIndex($contents, index)();
};

export default handleInit;



// WEBPACK FOOTER //
// ./src/scripts/components/tabs/handleInit.js